import * as Yup from 'yup';
import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { useDispatch } from 'react-redux';

import { Link, Stack, Checkbox, TextField, IconButton, InputAdornment, FormControlLabel } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { showError, showSuccess, showToast } from '../../../utils/toast';
import { useAddLoginMutation } from '../../../redux/login/LoginServices';
import useScriptRef from '../../../hooks/useScripyRef'
import { saveUser } from '../../../utils/session';
import { apiPostUnsecure, apiUrl } from '../../../utils/api';
import Iconify from '../../../components/iconify';
import { authTokenAction } from '../../../redux/auth/AuthReducer';

// ----------------------------------------------------------------------
const customId = "custom-id-yes";
export default function LoginForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const scriptedRef = useScriptRef();
  const [isLoading, setIsLoading] = useState(false);
  const [AddLogin, AddLoginInfo] = useAddLoginMutation()

  const [showPassword, setShowPassword] = useState(false);
  if (AddLoginInfo.isError) {
    showError("error", AddLoginInfo.msg);
    AddLoginInfo.reset();
  }
  useEffect(() => {
    if (AddLoginInfo.isSuccess) {
      dispatch(authTokenAction(AddLoginInfo.data.access));
      showSuccess("Welcome to Foodsy !! ")
      navigate('/dashboard/app', { replace: true });
      saveUser(AddLoginInfo.data)
    }
  }, [AddLoginInfo, dispatch, navigate])

  const LoginSchema = Yup.object().shape({
    username: Yup.string().required('UserName is required'),
    password: Yup.string().required('Password is required'),
  });

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
      remember: true,
    },
    validationSchema: LoginSchema,
    onSubmit: (values) => {
      AddLogin({
        username: values.username,
        password: values.password
      })
      setIsLoading(true);

    }

  });

  const { errors, touched, values, isSubmitting, handleChange, handleSubmit, getFieldProps } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <>
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              autoComplete="username"
              label="User Name"
              value={values.username}
              onChange={handleChange}
              {...getFieldProps('username')}
              error={Boolean(touched.username && errors.username)}
              helperText={touched.username && errors.username}
            />

            <TextField
              fullWidth
              autoComplete="current-password"
              type={showPassword ? 'text' : 'password'}
              label="Password"
              {...getFieldProps('password')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleShowPassword} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={Boolean(touched.password && errors.password)}
              helperText={touched.password && errors.password}
            />
          </Stack>

          <LoadingButton fullWidth size="large" type="submit" variant="contained" sx={{ mt: 2 }} loading={isLoading}>
            Login
          </LoadingButton>
        </Form>
      </FormikProvider>
    </>
  );
}
